export enum musicPlatform {
    Spotify = 'Spotify',
    YoutubeMusic = 'Youtube Music',
    AppleMusic = 'Apple Music',
    FitbeatMusic = 'Fitbeat Music',
}

interface IPlaylist {
    title: string;
    link: string;
}
export interface IMusicPlatformPlaylist {
    platformName: string;
    burnPlaylistLink: string;
    subHeading?: string;
    buildPlaylistLink: string;
    balancePlaylistLink: string;
    playlists?: IPlaylist[];
    platformPlaylistLink: string;
    platformLink: string;
    shouldScroll?: boolean;
}

export class MusicPlatformConfig {
    public static platformList: IMusicPlatformPlaylist[] = [{
        platformName: musicPlatform.Spotify,
        burnPlaylistLink: 'spotify:playlist:77AmB6leL9M6T9PCkRJ5q2',
        buildPlaylistLink: 'spotify:playlist:1kBbbvay0P1pzt3RfvwoJi',
        balancePlaylistLink: 'spotify:playlist:6x89gBPCEH9uwd6NwyEJ8S',
        platformPlaylistLink: 'spotify:playlist:7IOz8ywrTpGzndsqy5CxSx',
        platformLink: 'spotify:open',
        playlists: [
            {
                link: 'spotify:playlist:0LdcKspVj3uT7qiroV3Hrz',
                title: 'FITILLION Electric Dance',
            },
            {
                link: 'spotify:playlist:0RFVTTAmjVu6yCYYTgp49z',
                title: 'FITILLION Hip Hop (Old School)',
            },
            {
                link: 'spotify:playlist:4WO9erJZ0fsfgHTrJ525rK',
                title: 'FITILLION Rock',
            },
            {
                link: 'spotify:playlist:1owXdGFZhPx2Q4AwB7Xmfl',
                title: 'FITILLION Rock (Old School)',
            },
            {
                link: 'spotify:playlist:73zmv9lGTfMMTzVSETwM4A',
                title: 'FITILLION Hip Hop',
            },
            {
                link: 'spotify:playlist:1kBbbvay0P1pzt3RfvwoJi',
                title: 'FITILLION Build Playlist',
            },
            {
                link: 'spotify:playlist:77AmB6leL9M6T9PCkRJ5q2',
                title: 'FITILLION Burn Playlist',
            },
            {
                link: 'spotify:playlist:6x89gBPCEH9uwd6NwyEJ8S',
                title: 'FITILLION Balance Playlist',
            },
        ],
    }, {
        platformName: musicPlatform.AppleMusic,
        burnPlaylistLink: 'https://music.apple.com/au/playlist/fitillion-burn/pl.u-aZb0N69T1akyojo',
        buildPlaylistLink: 'https://music.apple.com/au/playlist/fitillion-build/pl.u-38oWZ6yTYGVdLxL',
        balancePlaylistLink: 'https://music.apple.com/au/playlist/fitillion-balance-1/pl.u-d2b05gLIL13D4q4',
        platformPlaylistLink: 'https://music.apple.com/us/playlist/pure-workout/pl.ad0ee1557e3e4feba314fd70f7982766',
        platformLink: 'https://music.apple.com/',
        playlists: [
            {
                link: 'https://music.apple.com/au/playlist/fitillion-electric-dance/pl.u-38oWZleuYGVdLxL',
                title: 'FITILLION Electric Dance',
            },
            {
                link: 'https://music.apple.com/au/playlist/fitillion-rock-old-school/pl.u-11zBJomsNLz2brb',
                title: 'FITILLION Rock (Old School)',
            },
            {
                link: 'https://music.apple.com/au/playlist/fitillion-rock/pl.u-e98lGLDta6oKdRd',
                title: 'FITILLION Rock',
            },
            {
                link: 'https://music.apple.com/au/playlist/fitillion-hip-hop-old-school/pl.u-d2b05V0TL13D4q4',
                title: 'FITILLION Hip Hop (Old School)',
            },
            {
                link: 'https://music.apple.com/au/playlist/fitillion-hip-hop/pl.u-aZb0NJ0T1akyojo',
                title: 'FITILLION Hip Hop',
            },
            {
                link: 'https://music.apple.com/au/playlist/fitillion-build/pl.u-38oWZ6yTYGVdLxL',
                title: 'FITILLION Build Playlist',
            },
            {
                link: 'https://music.apple.com/au/playlist/fitillion-burn/pl.u-aZb0N69T1akyojo',
                title: 'FITILLION Burn Playlist',
            },
            {
                link: 'https://music.apple.com/au/playlist/fitillion-balance-1/pl.u-d2b05gLIL13D4q4',
                title: 'FITILLION Balance Playlist',
            },
        ],
    }, {
        platformName: musicPlatform.YoutubeMusic,
        burnPlaylistLink: 'https://music.youtube.com/playlist?list=PLhKt2tecbfw5LKfs5j3TbzfwPLlZLNMXT',
        buildPlaylistLink: 'https://music.youtube.com/playlist?list=PLhKt2tecbfw6ACtXu9Y_Cl7XN-R3QRIOZ',
        balancePlaylistLink: 'https://music.youtube.com/playlist?list=PLhKt2tecbfw6ACtXu9Y_Cl7XN-R3QRIOZ',
        subHeading: 'Requires a Premium Youtube Music subscription',
        platformPlaylistLink: 'https://music.youtube.com/playlist?list=PLA_I2ay5YcUUr8_rE-DlVknObkJ6-Rn3q',
        platformLink: 'https://music.youtube.com',
        shouldScroll: true,
    }];
}
